export default __webpack_public_path__ + "static/media/elevate-cbb-poster-1.f59e66cc.jpg";